//
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProviderModel from '@/models/Purchase/PchProvider'
import PurchaseOrderStateModel from '@/models/Purchase/PchPurchaseOrderState'

//
export default [
    { 
        name    : 'id',
        props   : {
            hideDetails : true,
            label       : 'N° factura',
        },
        type    : 'text',
    },
    {
        name    : 'pch_provider_id',
        props   : {
            hideDetails : true,
            itemText    : 'business_name',
            itemValue   : 'id',
            label       : 'Proveedor',
            model       : ProviderModel,
            noObject    : true,
            paramSearch : 'search',
        },
        type    : 'autocomplete',
        value   : [],
    },
    {
        name    : 'pch_payment_condition_id',
        props   : {
            hideDetails : true,
            itemText    : 'type',
            itemValue   : 'id',
            label       : 'Condición de pago',
            model       : PaymentConditionModel,
            noObject    : true,
            paramSearch : 'type',
        },
        type    : 'autocomplete',
        value   : [],
    },
    {
        name    : 'pch_purchase_order_state_id',
        props   : {
            hideDetails : true,
            itemText    : 'state',
            itemValue   : 'id',
            label       : 'Estado',
            model       : PurchaseOrderStateModel,
            noObject    : true,
            paramSearch : 'state',
        },
        type    : 'autocomplete',
        value   : [],
    },
]